import api from "../../api/apiInterceptor";
import React from 'react';
import excelIcon from "../../images/excel.png"


function TableDownloadButton ({installationId, tableId}) {

    const getFile = () =>
    {
        api.get(`/api/installations/${installationId}/tableviews/${tableId}/dl`, {responseType: 'blob'})
        .then((response) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', `table-${installationId}-${tableId}.xlsx`); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        });
    }

    return (
        <div style={{textAlign: "right", margin: 10}}>
            <a title="Download this table in MS Excel format">
                <img src={excelIcon} onClick={getFile} />
            </a>
        </div>
    );

}

export default TableDownloadButton;